import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: theme.palette.grey[200],
    marginBottom: theme.spacing(1)
  },
  card: {
    display: 'flex',
    borderRadius: 6,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default
  },
  imageContainer: {
    width: 191,
    height: 137,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: 120,
      height: 120
    }
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    padding: 8,
    width: '100%',
    height: 137,
    [theme.breakpoints.down('sm')]: {
      height: 120,
      gridTemplateColumns: '1fr'
    }
  },
  image: {
    width: 191,
    height: 137,
    borderRadius: 6,
    objectFit: 'cover',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: 120,
      height: 120
    }
  },
  counter: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    background: theme.palette.grey[900],
    position: 'absolute',
    top: 10,
    left: 10,
    padding: '4px 8px',
    borderRadius: 6,
    opacity: 0.6
  },
  iconText: {
    lineHeight: 1,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    marginLeft: 6
  },
  photoIcon: { width: 14, height: 14, marginRight: 2 },
  left: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  textColor: {
    fontWeight: 600,
    color: theme.palette.grey[600],
    display: 'flex',
    verticalAlign: 'middle',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  header: { display: 'flex', flexDirection: 'column', flex: 2, gap: 4 },
  payment: { display: 'flex', flexDirection: 'column', flex: 1 },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    }
  },
  location: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  paymentChip: {
    marginTop: theme.spacing(1),
    padding: 2,
    background: theme.palette.grey[200],
    width: 'fit-content',
    '& .MuiChip-label': {
      fontSize: 12,
      color: theme.palette.grey[600]
    }
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    padding: 6,
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start'
    }
  },
  dateLabel: {
    color: theme.palette.grey[600],
    marginRight: 6,
    fontWeight: 500
  },
  dateValue: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  stars: {
    display: 'flex',
    color: '#fbc02d',
    height: '60%',
    alignItems: 'flex-start'
  },
  bottom: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0.5),
    height: '40%',
    alignItems: 'flex-start',
    justifyContent: 'end'
  },
  check: { display: 'flex', flexDirection: 'row' },
  icon: {
    fontSize: 18,
    marginRight: 4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  text: {
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    }
  }
}))
export default useStyles
